import { NextPageContext } from 'next';
import { AxiosError } from 'axios';
import { User } from 'context/AuthContext/AuthContext.types';
import { axiosAPI } from 'lib/api';
import { logInfo } from 'utils/logging';

const getUserData = async (
  context: NextPageContext | undefined,
): Promise<User | null> => {
  try {
    return await axiosAPI(
      {
        url: '/otvety/api/profile/users',
        method: 'GET',
      },
      context,
    );
  } catch (error) {
    const e = error as AxiosError;
    logInfo(e.toString(), true);
    return null;
  }
};

export default getUserData;
